import { inject, InjectionToken } from '@angular/core';

import { WINDOW } from './window';

export const LOCAL_STORAGE = new InjectionToken<Storage>(
  'window.localStorage object',
  {
    factory: (): Storage => inject(WINDOW).localStorage,
  },
);
